import axios from "axios";
import { BASE_URL, API_URL } from "./Urls";
import jwt_decode from "jwt-decode";
import { parseCookies } from "nookies";

const { token } = parseCookies();

export const api = axios.create({
  baseURL: API_URL,
  params: {
    t: new Date().getTime(),
  },
});

// Verificação de Token
export const VerifyIfTokenNotExpired = (token) => {
  let tokenDecoded = jwt_decode(token);

  if (!sessionStorage.getItem("plan_id")) {
    sessionStorage.setItem("plan_id", tokenDecoded.plan_id);
  }
  return tokenDecoded.exp > Date.now() / 1000;
};

// Lista de endpoints que não requerem autenticação
const publicEndpoints = [
  "/security/",
  "/auth/",
  "requests/index/login/",
  "api.tomtom.com",
  "celery-progress/",
  "users/validate_cpf",
  "users/create_first_admin",
  "viacep.com.br",
  "hereapi.com",
  "app.wabotty.com.br",
  "api/v1/google-api",
];

// Interceptor de requisição
api.interceptors.request.use(
  async function (config) {
    try {
      // Adiciona autenticação antes de verificar o cache
      let isPublicEndpoint = publicEndpoints.some((endpoint) =>
        config.url.includes(endpoint)
      );
      if (
        config.method === "post" &&
        config.url === `${process.env.REACT_APP_API_URL}account/`
      ) {
        isPublicEndpoint = true;
      }

      if (!isPublicEndpoint) {
        try {
          config.headers.Authorization = `Bearer ${token}`;
        } catch (error) {
          localStorage.clear();
          window.location.href = "/login";
          return;
        }
      }

      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Interceptor de resposta
api.interceptors.response.use(
  async function (response) {
    try {
      return response;
    } catch (error) {
      console.error("Erro ao processar resposta:", error);
      return response; // Retorna a resposta mesmo se houver erro no cache
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);
